var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-button',{on:{"click":_vm.handleClick}},[_vm._v("生成")]),_c('p')],1)}
var staticRenderFns = []

export { render, staticRenderFns }